import http from './http'

// 获取学校信息
export const getSchoolInfo = (programs) => http.get('api/scard/school/info', programs)

// 获取登录信息
export const getUserInfo = (programs) => http.get('api/scard/user/info', programs)

// 获取问题主页
export const getProblemIndex = (programs) => http.post('api/problem/index', programs)

// 获取问题下拉列表
export const getProblemList = (programs) => http.post('api/problem/type/box', programs)

// 获取处理问题
export const getDealProblem = (programs) => http.post('api/problem/update', programs)

// 处理结果上传
export const getProblemDetails = (programs) => http.post('/api/problem/details', programs)

// 访客列表
export const getVisitor = (programs) => http.postJson('api/visitor/info', programs)



// WEBPACK FOOTER //
// ./src/api/api.js